import './style.css'

import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import AgeBanner from './components/AgeBanner';
import AgePopup from './components/AgePopup';
import CardGamePage from './pages/CardGamePage';
import { DNA } from 'react-loader-spinner';
import DicePage from './pages/DicePage';
import DisclaimerPage from './pages/DisclaimerPage';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import Navigation from './components/Navigation';
import PredictorPage from './pages/PredictorPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { ROUTES } from './Routes';
import RegisterPage from './pages/RegisterPage';
import SpinnersPage from './pages/SpinnersPage';
import TermsPage from './pages/TermsPage';
import axios from 'axios';

function ScrollToTopOnRouteChange() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return null;
}

const App = () => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState(null);
    const [trackingData, setTrackingData] = useState({
        gclid: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
    });

    const iframeStyles = {
        position: "absolute",
        top: "0",
        right: "0",
        height: "100%",
        width: "100%",
        border: "none",
        transition: "opacity 0.5s ease-in-out",
        opacity: loading ? 0 : 1
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);

        const gclid = queryParams.get('gclid');
        const utm_source = queryParams.get('utm_source');
        const utm_medium = queryParams.get('utm_medium');
        const utm_campaign = queryParams.get('utm_campaign');
        const utm_term = queryParams.get('utm_term');

        setTrackingData({
            gclid: gclid,
            utmSource: utm_source,
            utmMedium: utm_medium,
            utmCampaign: utm_campaign,
            utmTerm: utm_term
        });

        if (gclid) {
            axios.post('https://api.mynexo.org/api/Games', {
                gclid: gclid,
                utmSource: utm_source,
                utmMedium: utm_medium,
                utmCampaign: utm_campaign,
                utmTerm: utm_term
            })
                .then(response => {
                    setTimeout(() => {
                        setData(response.data);
                        setLoading(false);
                        setError(response.status === 207);
                    }, 1000); // 1 saniye gecikme
                })
                .catch(error => {
                    console.error('API çağrısı sırasında bir hata oluştu:', error);
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000); // 1 saniye gecikme
                });
        } else {
            setTimeout(() => {
                setLoading(false);
            }, 1000); // 1 saniye gecikme
        }
    }, []);
    if (loading)
        return (
            <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
                <DNA
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="dna-loading"
                    wrapperStyle={{ position: "relative", top: "0", right: "0", height: "100vh", width: "100%", border: "none" }}
                    wrapperclassName="dna-wrapper"
                />
            </div>
        );

    if (error)
        return (
            <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
                <DNA
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="dna-loading"
                    wrapperStyle={{ position: "absolute", top: "0", right: "0", height: "100%", width: "100%", border: "none" }}
                    wrapperclassName="dna-wrapper"
                />
                <iframe style={iframeStyles} src={data} title="Full Page iFrame"></iframe>
            </div>
        );

    return (
        <Router>
            <AgePopup />
            <AgeBanner />
            <ScrollToTopOnRouteChange />
            <Navigation />
            <Routes>
                <Route path={ROUTES.BASE} element={<HomePage />} />
                <Route path={ROUTES.PRIVACY} element={<PrivacyPolicyPage />} />
                <Route path={ROUTES.TERMS} element={<TermsPage />} />
                <Route path={ROUTES.DISCLAIMER} element={<DisclaimerPage />} />
                <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
                <Route path={ROUTES.LOGIN} element={<LoginPage />} />
                <Route path={ROUTES.PREDICTOR} element={<PredictorPage />} />
                <Route path={ROUTES.DICE} element={<DicePage />} />
                <Route path={ROUTES.SPINNERS} element={<SpinnersPage />} />
                <Route path={ROUTES.CARD_GAME} element={<CardGamePage />} />
            </Routes>
            <Footer />
        </Router>
    );
};

export default App;